import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13.811",
  height: "15.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g data-name=\"Ikona LogOUT Wyloguj\"><g data-name=\"Group 8695\"><path fill=\"none\" stroke=\"#4493fc\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" stroke-width=\"1.5\" d=\"M7.234.75H2.746a2.06 2.06 0 0 0-2 2.117v9.766a2.06 2.06 0 0 0 2 2.117h4.488\" data-name=\"Path 16160\"></path></g><g fill=\"none\" stroke=\"#4493fc\" stroke-width=\"1.5\" data-name=\"Group 8701\"><path stroke-linecap=\"square\" stroke-miterlimit=\"10\" d=\"M5.75 7.748h5.468\" data-name=\"Line 521\"></path><path d=\"m9.418 4.418 3.333 3.333-3.333 3.332\" data-name=\"Path 16163\"></path></g></g>", 1)
  ]))]))
}
export default { render: render }